/* eslint-disable no-undef */
// import useOnlineStatus from "hooks/useDetectOnline";
import { Backdrop, Box, CircularProgress } from "@mui/material";
// import dynamic from "next/dynamic";
import React, { Suspense, useEffect, useState } from "react";
// import NextProgress from "next-progress";
// import HeaderSkeleton from "@/ui/Skeletons/HeaderSkeleton";
import useOnlineStatus from "../../hooks/useDetectOnline";

// import Sidebar from "../Sidebar/Sidebar";
// import { FadeLoader } from "react-spinners";
import assest from "../../json/assest";
import HeaderSkeleton from "../../ui/Skeletons/HeaderSkeleton";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import ManagerDashboardHeader from "../Header/ManagerDashboardHeader";
import SuperAdminHeader from "../Header/SuperAdminHeader";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useNavigate } from "react-router";
import { parseCookies } from "nookies";

// import Image from "next/image";

// const Header = dynamic(() => import("../Header/Header"), { suspense: true });
// const Footer = dynamic(() => import("../Footer/Footer"), { suspense: true });

const Wrapper = (props) => {
  const { userData } = useAppSelector((s) => s.userSlice);
  const cookies = parseCookies();
  const savedrole_Id = cookies?.role_id;
  const nav = useNavigate();

  useEffect(() => {
    if (savedrole_Id != 1) {
      //   <Navigate to="/page404" />;
      // nav("/page404");
      nav("/login");
    }
  }, [savedrole_Id]);

  const { children } = props;
  let [loading, setLoading] = useState(false);
  const handleClose = () => {
    setLoading(false);
  };
  useOnlineStatus();

  return (
    <>
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleClose}
        className="loader"
      > */}
      {/* <FadeLoader color="#5C5C5C" /> */}
      {/* <div className="loader-wrapper">
          <div className="loaderIcon">
            <img src={assest.logo_loader} alt="img" width={100} height={100} />
          </div>
        </div> */}
      {/* </Backdrop> */}

      {/* <NextProgress height={8} color="green" /> */}
      <Suspense fallback={<HeaderSkeleton />}>
        {/* <ManagerDashboardHeader /> */}

        <SuperAdminHeader />
      </Suspense>
      {savedrole_Id == 1 && (
        <Suspense>
          <Sidebar />
        </Suspense>
      )}
      {children}

      {/* <Suspense fallback={<HeaderSkeleton />}>
        <Footer />
      </Suspense> */}
    </>
  );
};

export default Wrapper;
